'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HistoryMobile = function (_Component) {
  (0, _inherits3.default)(HistoryMobile, _Component);

  function HistoryMobile() {
    (0, _classCallCheck3.default)(this, HistoryMobile);
    return (0, _possibleConstructorReturn3.default)(this, (HistoryMobile.__proto__ || (0, _getPrototypeOf2.default)(HistoryMobile)).apply(this, arguments));
  }

  (0, _createClass3.default)(HistoryMobile, [{
    key: 'render',
    value: function render() {
      var styles = require('./HistoryMobile.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.historyMobile },
        _react2.default.createElement(_components.HeaderMobile, { text: 'Lịch sử' }),
        _react2.default.createElement(
          'div',
          { className: styles.noHistory },
          _react2.default.createElement(
            'div',
            { className: styles.textNoHistory },
            'Ch\u01B0a c\xF3 d\u1EEF li\u1EC7u l\u1ECBch s\u1EED n\xE0o c\u1EE7a b\u1EA1n.'
          )
        )
      );
    }
  }]);
  return HistoryMobile;
}(_react.Component);

exports.default = HistoryMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/History/HistoryMobile.js
// module id = 1597
// module chunks = 0